import { EntityState, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { AbstractUiEntityStore } from 'projects/app-misc/src/app/modules/data/abstract-ui-entity.store';
import { Material } from '../../vendor/data/material';

export interface MatOrderState extends EntityState<Material, number> {
	ui: {
		searchQuery: string
	};
}

@Injectable({
	providedIn: 'root'
})
@StoreConfig({ name: 'materOrder' })
export class MatOrderStore extends AbstractUiEntityStore<MatOrderState> {
	constructor() {
		super({
			ui: {
				searchQuery: ''
			}
		})
	}

	updateSearchQuery(searchQuery: string) {
		this.updateUi({
			searchQuery
		})
	}
}